export default "__VITE_ASSET__BKG9F9mY__"